import { PropsWithChildren } from "react";
import { StudentFormData, useStudentForm } from "../StudentDataFormProvider";
import { Stack, styled, Typography } from "@mui/material";

type Props = {
  fieldName: keyof StudentFormData;
  label?: string;
  required?: boolean;
};

export const DateField = ({ fieldName, label, required = false }: PropsWithChildren<Props>) => {
  const {
    register,
    formState: { errors },
  } = useStudentForm();
  return (
    <Stack gap={"0.25rem"} width={"100%"}>
      {label && <label htmlFor={fieldName}>{label}</label>}
      <StyledInput type="date" {...register(fieldName, { required })}></StyledInput>
      {errors[fieldName] && (
        <Typography variant="caption" sx={{ color: "red" }}>
          {errors[fieldName]?.message}
        </Typography>
      )}
    </Stack>
  );
};

const StyledInput = styled("input")({
  borderRadius: "0.5rem",
  padding: "0.5rem",
  border: "1px solid #cbcbcb",
  fontSize: "1rem",
});
